"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _lottieWeb = _interopRequireDefault(require("lottie-web"));

var _deepmerge = _interopRequireDefault(require("deepmerge"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function throwError(msg) {
  throw new Error(msg);
}

function validate(animation) {
  if (animation === undefined) {
    throwError('Animation is not render - need to render');
  }
}

var IconAnimation = /*#__PURE__*/function () {
  function IconAnimation(animationId, options) {
    _classCallCheck(this, IconAnimation);

    var animation = getAnimationJson(animationId);
    var defaultOptions = {
      loop: true,
      autoplay: false
    };
    this.options = (0, _deepmerge.default)(defaultOptions, options || {}); // parse string to object

    if (animation === undefined) {
      throwError("Icon Animation is missing ".concat(animationId));
    }

    this.json = JSON.parse(animation);
  }

  _createClass(IconAnimation, [{
    key: "render",
    value: function render(container) {
      if (container === undefined) {
        throwError('container is missing');
        return;
      }

      this.animation = _lottieWeb.default.loadAnimation({
        container: container,
        renderer: 'svg',
        loop: this.options.loop,
        autoplay: this.options.autoplay,
        animationData: this.json
      });
    }
  }, {
    key: "addEventListener",
    value: function addEventListener(eventName, callback) {
      validate(this.animation);
      this.animation.addEventListener(eventName, callback);
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(eventName, callback) {
      validate(this.animation);
      this.animation.removeEventListener(eventName, callback);
    }
  }, {
    key: "stop",
    value: function stop() {
      validate(this.animation);
      this.animation.stop();
    }
  }, {
    key: "play",
    value: function play() {
      validate(this.animation);
      this.animation.play();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      validate(this.animation);
      this.animation.destroy();
      delete this.animation;
    }
  }]);

  return IconAnimation;
}();

exports.default = IconAnimation;